import { Navigate, Route, Routes } from "react-router-dom";

import { Shell } from "./components/Shell";
import { ErrorState, Loading } from "./components/ui";
import { useSession } from "./hooks/useSession";
import { AlertsPage } from "./pages/AlertsPage";
import { CostsPage } from "./pages/CostsPage";
import { DeploymentPage } from "./pages/DeploymentPage";
import { ExportPage } from "./pages/ExportPage";
import { InboxPage } from "./pages/InboxPage";
import { LessonsPage } from "./pages/LessonsPage";
import { LoginPage } from "./pages/LoginPage";
import { PortfolioPage } from "./pages/PortfolioPage";
import { ProductPage } from "./pages/ProductPage";
import { ProjectsPage } from "./pages/ProjectsPage";
import { SalesPage } from "./pages/SalesPage";
import { TeamPage } from "./pages/TeamPage";

export function App() {
  const session = useSession();

  if (session.isPending) {
    return <Loading label="Sprawdzam sesję…" />;
  }

  // Awaria serwera to nie „niezalogowany" — formularz logowania w tej sytuacji
  // kazałby wpisywać hasło, które niczego nie naprawi.
  if (session.isError) {
    return <ErrorState error={session.error} />;
  }

  if (!session.data) {
    return (
      <Routes>
        <Route path="/logowanie" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/logowanie" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<Shell />}>
        <Route path="/" element={<PortfolioPage />} />
        <Route path="/produkt/:slug" element={<ProductPage />} />
        <Route path="/produkt/:slug/:tab" element={<ProductPage />} />
        <Route path="/projekty" element={<ProjectsPage />} />
        <Route path="/sprzedaz" element={<SalesPage />} />
        <Route path="/koszty" element={<CostsPage />} />
        <Route path="/eksport" element={<ExportPage />} />
        <Route path="/alerty" element={<AlertsPage />} />
        <Route path="/bledy" element={<LessonsPage />} />
        <Route path="/wdrozenie" element={<DeploymentPage />} />
        <Route path="/zespol" element={<TeamPage />} />
        <Route path="/skrzynka" element={<InboxPage />} />
      </Route>
      <Route path="/logowanie" element={<Navigate to="/" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
